import api from '@/api'
import { setFormErrors } from '@/utils/helpers'
import _ from 'lodash'

export default {
  searchQuery({ commit }, { params }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      api.planner
        .search(params)
        .then((response) => {
          if (response.data.status) {
            resolve(response.data.data.hash)
          } else {
            commit('setDefaultError', 'An error occured , Please try in few seconds')
            resolve(false)
          }
        })
        .catch((error) => {
          if (error && _.has(error.response, 'data')) {
            if (!setFormErrors(error.response.data.errors, commit)) {
              if (_.has(error, 'error.response.data.message')) {
                commit('setDefaultError', error.response.data.message)
              } else {
                commit('setDefaultError', 'An error occured , Please try in few seconds')
              }
            }
          } else {
            commit('setDefaultError', 'An error occured , Please try in few seconds')
          }

          resolve(false)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    })
  },
}
